import { render, staticRenderFns } from "./FieldRegistration.vue?vue&type=template&id=114883fa&scoped=true&"
import script from "./FieldRegistration.vue?vue&type=script&lang=ts&"
export * from "./FieldRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./FieldRegistration.vue?vue&type=style&index=0&id=114883fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114883fa",
  null
  
)

export default component.exports